import styled from "styled-components";

export const TableContainer = styled.div`
  width: 100%;
  border: 1px solid #c4c4c4;
`;

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;

  td {
    height: 4rem;
  }
  thead {
    th {
      text-align: center;
      background: #585e66;
      color: #eff1f5;
      font-family: Sora;
      font-size: 0.8rem;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      height: 2.7rem;
    }
  }
  tbody {
    td {
      text-align: center;
      vertical-align: middle;
    }
  }
`;


export const TRLine = styled.tr`
  font-size: 0.85rem;
  background: ${({ checked }) => (checked ? "#cff8e7" : "#fff")};
  transition: background 2s ease-in-out;
`;


export const TaskDate = styled.span`
  align-items: center;
  display: flex;
  width: 8.8rem;

  padding: 0.2rem 0.3rem;
  border-radius: 0.2rem;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;

  background-color: ${({ status }) =>
    status === "doing"
      ? "#49B446"
      : status === "done"
        ? "#118052"
        : status === "doneLate"
          ? "#9F2D1D"
          : status === "pending"
            ? "#EFF1F5"
            : "#EB5757"};

  color: ${({ status }) => (status === "pending" ? "#7E858F" : "#FFFFFF")};

  path {
    stroke: ${({ status }) => (status === "pending" ? "#7E858F" : "#FFFFFF")};
  }
`;

export const TDStatus = styled.td`
  max-width: 17.4%;
`;

export const TDACC = styled.td`
  display: flex;
  min-width: 16.2%;
  align-items: center;
`;

export const StatusFormat = styled.span`
  padding: 0.2rem 0.7rem;
  border-radius: 0.2rem;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;

  background-color: ${({ status }) =>
    status === "doing"
      ? "#F8E47C"
      : status === "pending"
        ? "#EFF1F5"
        : status === "done"
          ? "#118052"
          : "#FFBAAB"};

  color: ${({ status }) =>
    status === "doing"
      ? "#786A23"
      : status === "pending"
        ? "#7E858F"
        : status === "done"
          ? "#EFF1F5"
          : "#D93333"};
`;

export const Title = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 1.4375rem;
  color: #212326;
  padding: 1rem;
`;
